import { useState } from 'react';
import { DashboardModal } from '@uppy/react';
import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { connect, type ConnectedProps } from 'react-redux';
import { API_URL, UPLOAD_URL } from '@/config';
import { user, setUpdatedUser } from '@/slices/user';
import { fetchMembers } from '@/slices/members';
import { type RootState } from '@/store';
import { type ModalContentProps } from '../../../state';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';

type Props = ConnectedProps<typeof connector> & ModalContentProps;

const FileUploadModal = ({
  closeModal,
  user,
  member_id,
  propertyId,
  setUpdatedUser,
  fetchMembers,
}: Props) => {
  const [uppy] = useState(() => {
    const uppy = new Uppy({
      restrictions: { maxNumberOfFiles: 1, allowedFileTypes: ['image/*'] },
    }).use(XHRUpload, {
      endpoint: member_id
        ? `${API_URL}/api/files/admin/avatar/${member_id}`
        : `${API_URL}/api/files/avatar/${user?.id}`,
      withCredentials: true,
    });

    uppy.on('complete', (result) => {
      if (member_id) {
        fetchMembers({
          propertyId,
        });
      } else {
        const fullPath = result.successful?.[0]?.response?.body?.fullPath;
        const avatar = `${UPLOAD_URL}/${fullPath}`;

        setUpdatedUser({ avatar });
      }
    });

    return uppy;
  });

  return (
    <DashboardModal
      uppy={uppy}
      open
      proudlyDisplayPoweredByUppy={false}
      note="Upload your avatar"
      onRequestClose={closeModal}
    />
  );
};

const connector = connect(
  (
    state: RootState,
    { modalData: { member_id, propertyId } = {} }: ModalContentProps,
  ) => ({
    user: user(state),
    member_id,
    propertyId,
  }),
  {
    fetchMembers,
    setUpdatedUser,
  },
);

export default connector(FileUploadModal);
